import React from 'react';
import PropTypes from 'prop-types';

import { useContext } from '@hooks';
import { mergeClasses } from '@utils';
import { BreadcrumbsContext } from './Breadcrumbs';

export default function BreadcrumbsBreadcrumb({
  children,
  className,
  href,
  isActive,
  ...restProps
}) {
  useContext(
    BreadcrumbsContext,
    'Breadcrumbs.Breadcrumb must be a child of Breadcrumbs.'
  );

  if (!children) return null;

  return (
    <li className="flex shrink-0 before:mr-1 before:w-auto before:text-dark-gray before:content-['/'] first:before:mr-0 first:before:content-none">
      {isActive ? (
        <span
          aria-current="page"
          className={mergeClasses('text-black', className)}
          {...restProps}
        >
          {children}
        </span>
      ) : (
        <a
          href={href}
          className={mergeClasses(
            'border-0 border-b border-solid border-transparent text-dark-gray no-underline hover:cursor-pointer hover:border-black focus:outline-none focus-visible:border-black',
            className
          )}
          {...restProps}
        >
          {children}
        </a>
      )}
    </li>
  );
}

BreadcrumbsBreadcrumb.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string.isRequired,
  isActive: PropTypes.bool
};

BreadcrumbsBreadcrumb.defaultProps = {
  children: undefined,
  className: '',
  isActive: false
};
